import React from "react"
import { withTranslation } from "react-i18next";
import { ValidateRepseDocumentView } from "../../views"
import { LocalStorageService, WorkflowService, WorkflowMessagesService } from "../../../services";
import { socket } from "../../../Context";
import { getNavigatorTimezone } from "../../../utils";

class ValidateRepseDocumentAction extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            token: '',
            user: {},
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
            url: '',
            documentRepse: {},
            providerName: '',
            registerDate: '',
            documentName: '',
            membersChat: [],
            usersChat: {},
            conversation: [],
            file: {},
            documents: [],
            contract: {
                companyName: '',
                contractorName: '',
                name: '',
                yearMonth: ''
            },
            workflowExecutionInfo: {},
        }
    }

    token = {};
    user = {}
    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService();
    workflowService = new WorkflowService(this.url);
    workflowMessagesService = new WorkflowMessagesService(this.url);

    workflowExecutionId = ''
    idAuthorMessage = 0;
    timezone = getNavigatorTimezone()


    async componentDidMount() {
        this.toggleLoadingScreen(true);
        let urlArr = window.location.href.split("/");
        this.workflowExecutionId = urlArr[urlArr.length - 1].includes('?') ? urlArr[urlArr.length - 1].split('?')[0] : urlArr[urlArr.length - 1];

        //call sockets
        socket.on("messages", (data) => this.addNewMessageSocket(data));

        this.token = this.localStorageService.getLocalStorageItem("token").idToken;
        this.user = this.localStorageService.getLocalStorageItem("user");
        this.getRepseDocument()
        this.getWorkExecutionId()
        this.getMessages()
        this.setState({
            user: this.user,
            token: this.token,
        })
    }

    toggleLoadingScreen = (value) => {
        this.setState({
            isLoading: value
        })
    }

    toggleErrorRequesting = (value, message, time, sendInbox) => {
        this.setState({
            showErrorRequesting: value,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    this.props.history.push("/");
                }
            }, time)
        })
    }


    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    toggleCompletedRequesting = (value) => {
        this.setState({
            showCompletedRequesting: value,
        });
    }

    getRepseDocument = async () => {
        let errorRepse = 'Ocurrió un error al consultar el documento'
        try {
            let repseDocument = await this.workflowService.getDocumentRepseByWorkflow(this.workflowExecutionId, this.token)
            if (repseDocument && repseDocument.data && Number(repseDocument.statusCode) === 200) {

                let documents = repseDocument.data.documents.map((doc) => {
                    doc.loadedDate = (doc.updatedDate) ? `Cargado el ${doc.updatedDate}` : 'Cargado'
                    doc.nameUser = repseDocument.data.contract.nameUser
                    return doc
                })

                this.setState({
                    documents,
                    contract: repseDocument.data.contract
                })
                this.toggleLoadingScreen(false);

            } else {
                this.toggleLoadingScreen(false);
                this.toggleErrorRequesting(true, errorRepse, 4000, true)
            }
        } catch (error) {
            this.toggleLoadingScreen(false);
            this.toggleErrorRequesting(true, errorRepse, 4000, true)
        }
    }

    handleClickBack = () => {
        this.props.history.goBack()
    }

    handleChangeStatus = async (action, documentsRejected) => {
        this.toggleLoadingRequesting(true)
        let errorMessage = 'Ocurrió un error al cambiar el status del workflow'
        try {
            //change status workflow status
            let workflowExecution = await this.workflowService.updateStatusWorkflowREPSE(this.workflowExecutionId, action, documentsRejected, this.token);
            if (workflowExecution && workflowExecution.data && Number(workflowExecution.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(true)
                setTimeout(() => {
                    this.toggleCompletedRequesting(false)
                    this.props.history.push('/')
                }, 4000)
            } else {
                this.toggleLoadingRequesting(false);
                this.toggleErrorRequesting(true, errorMessage, 4000)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false);
            this.toggleErrorRequesting(true, errorMessage, 4000)
        }
    }

    //change status workflow to send next status
    handleValidateDocument = async () => {
        this.toggleLoadingRequesting(true)
        let errorMessage = 'Ocurrió un error al cambiar el status del workflow'
        try {
            let validateDocuments = await this.workflowService.validateDocumentsRepseByWorkflowExecutionId(this.workflowExecutionId, this.token)
            if (validateDocuments && validateDocuments.data && Number(validateDocuments.statusCode) === 200) {
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(true)
                setTimeout(() => {
                    this.toggleCompletedRequesting(false)
                    this.props.history.push('/')
                }, 4000)
            } else {
                this.toggleLoadingRequesting(false);
                this.toggleErrorRequesting(true, errorMessage, 4000)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false);
            this.toggleErrorRequesting(true, errorMessage, 4000)
        }
    }

    handleInputChangeChat = (e) => {
        let file = e.target.files[0];
        this.setState({
            file
        })
    }

    getMessages = async () => {
        let errorMessages = "Ocurrió un error al consultar los mensajes";
        let user = {};
        try {
            //Get message and members chat
            let workflowMessage =
                await this.workflowMessagesService.getWorkFlowExecutionMessage(
                    this.workflowExecutionId,
                    this.timezone,
                    this.token
                );
            if (
                workflowMessage &&
                workflowMessage.data &&
                Number(workflowMessage.statusCode) === 200
            ) {
                //Filter out duplicated members
                let membersChat = workflowMessage.data.workflowExecutionMembers.filter((member, index) =>
                    workflowMessage.data.workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
                );
                //users chat
                membersChat.map((member) => {
                    member.id = member.workflowExecutionMemberId;
                    member.avatarUrl = member.profilePicture;
                    member.name = member.firstName + " " + member.firstLastName;
                    member.avatarAltText = member.firstName + " " + member.firstLastName;
                    if (this.user.userMetaData.userA3Cloud.email === member.email) {
                        this.idAuthorMessage = member.id;
                        user = member;
                    }
                    return membersChat;
                });

                //Message chat
                workflowMessage.data.workflowExecutionMessages.map((member) => {
                    member.author = {
                        name: member.firstName + " " + member.firstLastName,
                        id: member.workflowExecutionMemberId,
                        avatarUrl: member.profilePicture,
                    };
                    member.timestamp = new Date(member.createdDate);
                    member.text = member.workflowExecutionMemberMessage;
                    member.id = member.workflowExecutionMemberId;
                    member.name = member.firstName + " " + member.firstLastName;
                    member.avatarUrl = member.profilePicture;
                    if (member.workflowExecutionMemberMessageDoc.length > 0) {
                        member.attachments = [
                            {
                                name: member.workflowExecutionMemberMessageDoc[0]?.documentName,
                                site: member.workflowExecutionMemberMessageDoc[0]?.documentPath,
                            },
                        ];
                    }
                    return workflowMessage.data.workflowExecutionMessages;
                });
                this.setState({
                    membersChat: membersChat,
                    conversation: workflowMessage.data.workflowExecutionMessages,
                    usersChat: user,
                });
                this.toggleLoadingRequesting(false);
            } else {
                this.toggleLoadingScreen(false);
                this.toggleErrorRequesting(true, errorMessages, 4000, true)
            }
        } catch (error) {
            this.toggleLoadingScreen(false);
            this.toggleErrorRequesting(true, errorMessages, 4000, true)
        }
    };

    //Function to create message
    createMessage = async (messagesChat, fileContent) => {
        let data = new FormData();
        data.append("workflowExecutionId", this.workflowExecutionId);
        data.append("workflowExecutionMemberId", this.idAuthorMessage);
        data.append("message", messagesChat.text);
        data.append("documento", fileContent);
        data.append("timezone", this.timezone)

        await this.workflowMessagesService.createWorkflowExecutionNewMessage(
            data,
            this.token
        );
    };

    markChatAsRead = async () => {
        try {
            await this.workflowMessagesService.markAsRead(this.workflowExecutionId, this.token)
        } catch (e) { }
    };

    //add a new meessage to conversation when sockets send a mew message
    addNewMessageSocket = (message) => {
        let copyConversation = [...this.state.conversation];
        let indexMessage = copyConversation.length;

        let newMessage = {
            author: {
                name: `${message.firstName} ${message.firstLastName}`,
                id: Number(message.workflowExecutionMemberId),
                avatarUrl: message.profilePicture,
            },
            timestamp: message.workflowExcecutionMemberMessage
                ? new Date(message.workflowExcecutionMemberMessage.createdDate)
                : new Date(
                    message.workflowExecutionMemberMessageDocName[0].createdDate
                ),
            text: message.workflowExcecutionMemberMessage.message,
            id: Number(message.workflowExecutionMemberId),
            name: `${message.firstName} ${message.firstLastName}`,
            avatarUrl: message.profilePicture,
            workflowExecutionMemberId: Number(message.workflowExecutionMemberId),
            workflowExecutionMemberMessage:
                message.workflowExcecutionMemberMessage.message === "" ||
                    message.workflowExcecutionMemberMessage.message === "undefined"
                    ? null
                    : message.workflowExcecutionMemberMessage.message,

            email: message.email,
            firstName: message.firstName,
            firstLastName: message.firstLastName,
            profilePicture: message.profilePicture,
            selectionIndex: indexMessage,
        };
        if (message.workflowExecutionMemberMessageDocName.length > 0) {
            newMessage.workflowExecutionMemberMessageDoc = [
                {
                    name: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocName
                        : "",
                    site: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocURL
                        : "",
                },
            ];
            newMessage.attachments = [
                {
                    name: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocName
                        : "",
                    site: message.workflowExecutionMemberMessageDocName
                        ? message.workflowExecutionMemberMessageDocName[0]
                            .workflowExecutionMemberMessageDocURL
                        : "",
                },
            ];
        }

        copyConversation.push(newMessage);
        this.setState({
            conversation: copyConversation,
        });
    };

    async getWorkExecutionId() {
        let errorMessage = 'Ocurrió un error al consultar el workflow del contrato'

        let workflowExecutionId = this.workflowExecutionId;
        this.setState({ workflowExecutionId: workflowExecutionId });
        try {
            let workflowExecution =
                await this.workflowService.getWorkFlowExecutionById(
                    workflowExecutionId,
                    this.token
                );
            if (
                workflowExecution &&
                workflowExecution.data &&
                Number(workflowExecution.statusCode) === 200
            ) {
                let statusCurrent =
                    workflowExecution.data.workflowStatusDescriptions.statusCurrent
                        .status;
                let currenteName =
                    workflowExecution.data.workflowStatusDescriptions.statusCurrent.name;

                this.setState({
                    workflowExecutionInfo: workflowExecution.data,
                    titleView: currenteName,
                    status: statusCurrent,
                });
            } else {
                this.toggleLoadingRequesting(false);
                this.toggleErrorRequesting(true, errorMessage, 4000)
            }
        } catch (error) {
            this.toggleLoadingRequesting(false);
            this.toggleErrorRequesting(true, errorMessage, 4000)
        }
    }

    render() {
        return (
            <ValidateRepseDocumentView
                {...this.state}
                toggleCompletedRequesting={this.toggleCompletedRequesting}
                toggleErrorRequesting={this.toggleErrorRequesting}
                toggleLoadingRequesting={this.toggleLoadingRequesting}
                handleClickBack={this.handleClickBack}
                handleValidateDocument={this.handleValidateDocument}
                handleChangeStatus={this.handleChangeStatus}
                handleInputChangeChat={this.handleInputChangeChat}
                createMessage={this.createMessage}
                markChatAsRead={this.markChatAsRead}
            />
        )
    }
}

export default withTranslation()(ValidateRepseDocumentAction);
